import { Routes } from '@angular/router';
import { adminGuard } from './app/core/guards/admin.guard';
import { portalGuard } from './app/core/guards/portal.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/admin/login', pathMatch: 'full' },

  // Admin routes
  {
    path: 'admin/login',
    loadComponent: () =>
      import('./app/features/admin/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'admin/set-password',
    loadComponent: () =>
      import('./app/features/admin/set-password/set-password.component').then((m) => m.SetPasswordComponent),
  },
  {
    path: 'admin/change-password',
    canActivate: [adminGuard],
    loadComponent: () =>
      import('./app/features/admin/change-password/change-password.component').then((m) => m.ChangePasswordComponent),
  },
  {
    path: 'admin',
    canActivate: [adminGuard],
    loadComponent: () =>
      import('./app/features/admin/admin-layout.component').then((m) => m.AdminLayoutComponent),
    children: [
      {
        path: 'dashboard',
        redirectTo: 'inbox',
        pathMatch: 'full',
      },
      {
        path: 'inbox',
        loadComponent: () =>
          import('./app/features/admin/dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },
      {
        path: 'practices',
        loadComponent: () =>
          import('./app/features/admin/practices/practices-list.component').then((m) => m.PracticesListComponent),
      },
      {
        path: 'practices/new',
        loadComponent: () =>
          import('./app/features/admin/practices/practice-form.component').then((m) => m.PracticeFormComponent),
      },
      {
        path: 'practices/:id',
        loadComponent: () =>
          import('./app/features/admin/practices/practice-detail.component').then((m) => m.PracticeDetailComponent),
      },
      {
        path: 'doctors',
        loadComponent: () =>
          import('./app/features/admin/doctors/doctors-list.component').then((m) => m.DoctorsListComponent),
      },
      {
        path: 'doctors/:id',
        loadComponent: () =>
          import('./app/features/admin/doctors/doctor-detail.component').then((m) => m.DoctorDetailComponent),
      },
      {
        path: 'form-requests',
        loadComponent: () =>
          import('./app/features/admin/form-requests/form-requests-list.component').then((m) => m.FormRequestsListComponent),
      },
      {
        path: 'form-requests/:id',
        loadComponent: () =>
          import('./app/features/admin/form-requests/form-request-detail.component').then((m) => m.FormRequestDetailComponent),
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./app/features/admin/users/users-list.component').then((m) => m.UsersListComponent),
      },
      {
        path: 'insurers',
        loadComponent: () =>
          import('./app/features/admin/insurers/insurers-list.component').then((m) => m.InsurersListComponent),
      },
      {
        path: 'insurers/:id',
        loadComponent: () =>
          import('./app/features/admin/insurers/insurer-detail.component').then((m) => m.InsurerDetailComponent),
      },
      {
        path: 'practices/:practiceId/patients/new',
        loadComponent: () =>
          import('./app/features/admin/patients/patient-form.component').then((m) => m.PatientFormComponent),
      },
      {
        path: 'practices/:practiceId/assistants/new',
        loadComponent: () =>
          import('./app/features/admin/assistants/assistant-form.component').then((m) => m.AssistantFormComponent),
      },
      {
        path: '',
        redirectTo: 'inbox',
        pathMatch: 'full',
      },
    ],
  },

  // Auth routes
  {
    path: 'auth/verify',
    loadComponent: () =>
      import('./app/features/auth/magic-link-handler.component').then((m) => m.MagicLinkHandlerComponent),
  },
  {
    path: 'auth/request-link',
    loadComponent: () =>
      import('./app/features/auth/request-link.component').then((m) => m.RequestLinkComponent),
  },

  // Portal routes
  {
    path: 'portal/form-requests',
    canActivate: [portalGuard],
    loadComponent: () =>
      import('./app/features/portal/form-request-list/form-request-list.component').then((m) => m.FormRequestListComponent),
  },
  {
    path: 'portal/form-requests/:id/alternative',
    canActivate: [portalGuard],
    loadComponent: () =>
      import('./app/features/portal/form-alternative/form-alternative.component').then((m) => m.FormAlternativeComponent),
  },
  {
    path: 'portal/form-requests/:id',
    canActivate: [portalGuard],
    loadComponent: () =>
      import('./app/features/portal/form-host/form-host.component').then((m) => m.FormHostComponent),
  },

  { path: '**', redirectTo: '/admin/login' },
];
